// @flow

import styled, { css } from "styled-components";

import buildColor from "../../_static/ColorPalette";
import { buildTextHighlighted, TYPES } from "../../_atom/TextHighlighted";

export const TextHighlighted = styled(
  buildTextHighlighted(TYPES.pending, 11, true, true)
)`
  padding: 1px 2px;
  line-height: 1;
`;

export const TabsContainer = styled.section`
  margin-top: 0;
  ${(props) =>
    props.device === "tablet"
      ? css`
          overflow: hidden;
          border: 1px solid ${buildColor("grey", "300")};
          border-radius: 2px;
          margin-top: 8px;
        `
      : css`
          border-top: 1px solid ${buildColor("grey", "300")};
          border-bottom: 1px solid ${buildColor("grey", "300")};
          z-index: 1;
        `};
`;

export const ComponentContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
